export default {
    "name": "GetPartnersBoxMaps",
    "kind": "HoudiniQuery",
    "hash": "f022766c6354192dcb6cf4a2c0dcfd0cdd0a53b768cd2611432d61c28a9d4bfd",

    "raw": `query GetPartnersBoxMaps($input: GetPartnersBoxMapsInput!) {
  getPartnersBoxMaps(input: $input) {
    ... on GetPartnersBoxMapsResultSuccess {
      __typename
      type
      boxMaps {
        type
        message
        url
        tracking
        img
        shortMessage
      }
    }
    ... on GetPartnersBoxMapsResultNotFound {
      message
      __typename
    }
    __typename
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getPartnersBoxMaps": {
                "type": "GetPartnersBoxMapsResult",
                "keyRaw": "getPartnersBoxMaps(input: $input)",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "GetPartnersBoxMapsResultSuccess": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "type": {
                                    "type": "GetPartnersBoxMapsResultResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "boxMaps": {
                                    "type": "BoxMap",
                                    "keyRaw": "boxMaps",

                                    "selection": {
                                        "fields": {
                                            "type": {
                                                "type": "AdvertisingPartnerType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "message": {
                                                "type": "String",
                                                "keyRaw": "message",
                                                "visible": true
                                            },

                                            "url": {
                                                "type": "String",
                                                "keyRaw": "url",
                                                "visible": true
                                            },

                                            "tracking": {
                                                "type": "String",
                                                "keyRaw": "tracking",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "img": {
                                                "type": "String",
                                                "keyRaw": "img",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "shortMessage": {
                                                "type": "String",
                                                "keyRaw": "shortMessage",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                }
                            },

                            "GetPartnersBoxMapsResultNotFound": {
                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetPartnersBoxMapsInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "GetPartnersBoxMapsInput": {
                "arrivalName": "String",
                "coordinates": "CoordinatesInput",
                "departureName": "String",
                "distance": "Float"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=5c61dcb3c10858139506619470a09151b5ab36e38f4ac4dd22ce8eb69ffb0d86";